<template>
  <div v-lenis-scroll class="main">
    <div class="overlay" />
    <div class="subkoscroll" :style="{ backgroundImage: 'url(' + backgroundImage + ')' }" />
    <div class="subkoscroll-bottomsection">
      <div class="none" />
      <div class="rightsideimagebox">
        <img
          class="subkoscrollrightside"
          :src="shopifyData.logo"
          alt="text_White"
          loading="lazy"
          aria-hidden="true"
          aria-label="Text White"
          width=""
          height=""
        />
        <div class="limitededition">
          <h2 class="sectiontext1">GET YOUR</h2>
          <h2 class="sectiontext2">LIMITED EDITION</h2>
          <h2 class="sectiontext3">BEHNO NEW YORK x SUBKO TOTE BAG</h2>
          <!-- <a :href="(shopifyData.btnLink)" class="sourdoughbtn"></a> -->
          <!-- 
                              <a :href="(shopifyData.btnLink)" class="sourdoughbtn" link="shopifyData.btnLink">
                                    {{ shopifyData.btnTitle }}
                              </a> -->
          <a
            :href="computedHref"
            :data-available="productAvailable"
            class="sourdoughbtn"
            @click="handleClick"
          >
            {{ shopifyData.btnTitle }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth, // Track window width
    };
  },
  computed: {
    // Dynamic background image based on window width
    backgroundImage() {
      return this.windowWidth <= 676 ? this.shopifyData.mobBg : this.shopifyData.desktopBg;
    },
    productAvailable() {
      return this.shopifyData.isAvailable === 'true' || this.shopifyData.isAvailable === true;
    },
    computedHref() {
      return this.productAvailable ? this.shopifyData.btnLink : '#';
    },
  },
  mounted() {
    window.addEventListener('load', () => {
      // console.log("Window fully loaded, shopifyData:", this.shopifyData);
    });

    gsap.registerPlugin(ScrollTrigger);

    gsap.timeline({
      scrollTrigger: {
        trigger: '.subkoscroll',
        start: '0% 0%',
        end: '100% 50%',
        scrub: 3,
        pin: true,
        pinSpacing: true,
      },
    });

    gsap.timeline({
      scrollTrigger: {
        trigger: '.subkoscroll-bottomsection',
        start: '50% 30%',
        end: '50% top',
        scrub: 3,
        // markers:true
      },
    });

    // Set correct background image on load
    this.updateBackgroundImage();

    // Listen for window resize events
    window.addEventListener('resize', this.updateBackgroundImage);
  },
  beforeUnmount() {
    // Remove event listener on component unmount
    window.removeEventListener('resize', this.updateBackgroundImage);
  },
  methods: {
    handleClick(event) {
      if (!this.productAvailable) {
        event.preventDefault();
      }
    },
    // Update background image on resize
    updateBackgroundImage() {
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>

<style scoped>
.main {
  position: relative;
}

.subkoscroll {
  /* background-image: url("section2.png"); */
  background-position: center;
  background-repeat: no-repeat;
  background-size: inherit;
  height: 100vh;
  position: relative;
}

.subkoscroll-bottomsection {
  display: grid;
  grid-template-columns: 50% 50%;
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 30%;
}

.overlay {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  background-color: black;
  opacity: 0.3;
  z-index: 1;
}

.limitededition {
  border: 1px solid #d9d9d9;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px 53px;
  z-index: 4;
}

.sectiontext1 {
  font-family: 'Helvetica Neue', sans-serif;
  font-size: 13px;
  font-weight: 700;
  line-height: 11.83px;
  text-align: center;
  color: #d9d9d9;
}

.sectiontext2 {
  font-family: 'PP Editorial New', sans-serif;
  font-size: 36px;
  font-style: italic;
  font-weight: 200;
  line-height: 0.9;
  text-align: center;
  color: #d9d9d9;
  padding: 10px 0;
}

.sectiontext3 {
  font-family: 'Helvetica Neue', sans-serif;
  font-size: 13px;
  font-weight: 700;
  line-height: 0.9;
  text-align: center;
  color: #d9d9d9;
}

.rightsideimagebox {
  display: flex;
  justify-content: center;
  gap: 100px;
  align-items: center;
  flex-direction: column;
  z-index: 4;
  padding: 0 20px;
}

.subkoscrollrightside {
  position: relative;
  z-index: 9;
  max-width: 430px;
  width: 100%;
  height: 226px;
  margin-top: 100px;
  margin-bottom: 100px;
}

.sourdoughbtn {
  border: none;
  border-radius: 20px;
  font-family: 'Helvetica Neue', sans-serif;
  font-size: 15px;
  font-weight: 700;
  line-height: 0.9;
  text-align: center;
  margin-top: 20px;
  background-color: #d9d9d9;
  color: #000000;
  padding: 20px 26px 20px 26px;
  cursor: pointer;
  position: relative;
}

.sourdoughbtn::after {
  content: 'SOLD OUT.';
  border: none;
  border-radius: 20px;
  position: absolute;
  font-family: 'Helvetica Neue', sans-serif;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #d9d9d9;
  font-size: 15px;
  font-weight: 700;
  line-height: 0.9;
  color: #000000;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.sourdoughbtn[data-available='false']:hover::after {
  opacity: 1;
}

@media screen and (max-width: 991px) {
  .sourdoughbtn[data-available='false']::after {
    opacity: 1;
  }

  .subkoscroll-bottomsection {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }

  .sectiontext3 {
    font-size: 10px;
  }

  .none {
    display: none;
  }

  .subkoscroll {
    /* background-image: url(./section2imageres.png); */
    height: 100vh;
    background-size: cover;
  }

  .subkoscrollrightside {
    max-width: 300px;
    height: 100px;
    object-fit: cover;
  }

  .limitededition {
    padding: 13px 33px;
  }

  .sourdoughbtn {
    padding: 11px 12px;
    text-wrap: nowrap;
    font-size: 10px;
  }

  .sectiontext2 {
    font-size: 20px;
  }

  .sectiontext1 {
    font-size: 12px;
  }
}
</style>
